import type { SearchSource } from './types'

export const getSuggestList = (searchSource: SearchSource) => {
  if (searchSource === 'input') {
    return 'match_text'
  }
  if (searchSource === 'suggestions') {
    return 'example list'
  }
  if (searchSource === 'select') {
    return 'category list - unRelated'
  }
  return 'unknown' as never
}
